import React from 'react'
import { AflMatchSummaryWidgetContainer } from './AflMatchSummaryWidget.styled'

export interface AflMatchSummaryWidgetProps {
    competition: string
    season: string
    match: string
}
export const AflMatchSummaryWidget = ({
    competition,
    match,
    season,
}: AflMatchSummaryWidgetProps) => {
    return (
        <AflMatchSummaryWidgetContainer>
            <opta-widget
                widget="match_summary"
                template="normal"
                competition={competition}
                season={season}
                match={match}
                live="true"
                show_match_header="true"
                show_score="true"
                show_quarters="true"
                show_scorers="true"
                show_crests="false"
                show_date="true"
                date_format="dddd D MMMM YYYY"
                show_competition_name="true"
                show_venue="true"
                competition_naming="full"
                team_naming="full"
                player_naming="full"
                show_title="false"
                show_logo="false"
                show_live="false"
                breakpoints="400, 700"
                sport="afl"
            ></opta-widget>
        </AflMatchSummaryWidgetContainer>
    )
}
